import { ContextNamespace } from 'app/constants/Context';

export function getDataGaEventByNamespace(
  namespace: ContextNamespace,
  event : string,
) {
  switch (namespace){
    case ContextNamespace.LIVE:
      return `live-${event}`;
    case ContextNamespace.PREMATCH:
    case ContextNamespace.PREMATCH_MATCHES: {
      return `line-${event}`;
    }
    case ContextNamespace.FAVORITES: {
      return `favorites-${event}`;
    }
    case ContextNamespace.INTERESTING_MATCHES:
      return `highlights-${event}`;
    case ContextNamespace.MATCH_OF_THE_DAY:
      return `matсhofday-${event}`;
    default:
      assertExhaustiveness(namespace);
  }
}
